import React from "react";
import { useNavigate } from "react-router-dom";

import backIcon from "../../assets/icons/back-arrow-svgrepo-com.svg";

const BackButton = () => {
  const navigate = useNavigate();

  const handleBackClick = () => {
    navigate(-1); // Goes back one step in history
  };

  return (
    <button onClick={handleBackClick} className="p-2 hover:bg-secondary-40 rounded-full">
      <img src={backIcon} alt="" width={24} height={24} />
    </button>
  );
};

export default BackButton;
